
export { default as propOr } from "./propOr.js"